module.exports = __webpack_public_path__ + "static/media/add_btn.006c1d13.svg";